import Icon from '@/features/analytics/invite-links/ui/Marking/icon'
import { AnalyticsTableRowType } from '@/features/analytics/types'
import { QuestionSVGIcon } from '@/shared/assets'
import { useCopyToClipboard } from '@/shared/hooks'
import { Checkbox, Input, Toast } from '@/shared/ui'
import { Label } from '@/shared/ui/label'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/tooltip'
import { ORDMarkingFormData } from '@synapex/prisma/client'
import { useId } from 'react'
import { telegramGetMessageTmeUrl } from '@synapex/shared2/telegram'

type PublishedPost = {
    markingFormData: ORDMarkingFormData
    analyticsTableRowType: AnalyticsTableRowType
    isLinkDeleted: boolean
}

const PublishedPost: React.FC<PublishedPost> = ({
    markingFormData,
    analyticsTableRowType,
    isLinkDeleted,
}) => {
    const { copy, toastVisible, toastMessage, hideToast } = useCopyToClipboard()

    const id = useId()

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation()
        if (currentUrl) {
            copy(currentUrl)
        }
    }

    const { publisher } = analyticsTableRowType

    const currentUrl =
        (publisher && publisher.telegram_post_id
            ? telegramGetMessageTmeUrl(
                  {
                      id: publisher.telegram_channel_id,
                      username:
                          publisher.telegram_channel_username ?? undefined,
                  },
                  publisher.telegram_post_id
              )?.href
            : null) ?? ''
    // If current date is greater than deleted date + 1, and post is not deleted, show error
    const error =
        !isLinkDeleted &&
        markingFormData.deleted_date &&
        new Date(markingFormData.deleted_date).getTime() + 24 * 60 * 60 * 1000 <
            new Date().getTime()

    return (
        <div className="flex flex-col gap-[6px]">
            <div className="flex gap-9">
                <div className="flex items-center gap-[6px]">
                    <Icon
                        icon="noImage"
                        checked={isLinkDeleted}
                        error={!!error}
                    />

                    <h2 className="text-sm font-semibold">
                        Опубликованный пост
                    </h2>

                    <Tooltip>
                        <TooltipTrigger>
                            <QuestionSVGIcon className="cursor-pointer" />
                        </TooltipTrigger>
                        <TooltipContent side="top">
                            <p>Опубликованный пост</p>
                        </TooltipContent>
                    </Tooltip>
                </div>
            </div>

            <div className="flex items-end justify-between gap-8">
                <div className="flex w-[448px] items-center gap-2">
                    <div className="relative flex w-full flex-col gap-[6px]">
                        <span className="text-[10px] text-synapex-light-gray">
                            Ссылка на пост
                        </span>
                        <Input
                            onClick={handleCopy}
                            innerClassName="h-[32px] text-blue-primary cursor-pointer"
                            value={currentUrl}
                            readOnly
                            placeholder="Ссылка появится после публикации"
                            shouldShowClearButton={false}
                            disabled={isLinkDeleted}
                        />
                        <Toast
                            message={toastMessage}
                            visible={toastVisible}
                            onClose={hideToast}
                            greenSwooshIcon={true}
                            className="toast__marking-modal"
                        />
                    </div>
                </div>

                <div className="flex w-[105px] items-center gap-[6px] pb-[5px]">
                    <Checkbox
                        id={id}
                        disabled
                        defaultChecked={isLinkDeleted}
                        sizeVariant="big"
                        variant={'green'}
                        size={20}
                    />
                    <Label
                        htmlFor={id}
                        className="w-[79px] text-[10px] font-medium leading-3"
                    >
                        Креатив удален
                    </Label>
                </div>
            </div>
        </div>
    )
}

export default PublishedPost
